import classnames from 'classnames'
import GatsbyImage from 'gatsby-image'
import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../../utils/ReactUtils'
import Img from 'gatsby-image'

import styles from './styles'
import { useRef } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'


const decorators = [
  memoized,
]

function MenuImage({ image, isActive, x, y }) {

  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })
  const ref = useRef()
  
  useEffect(() => {
    if (ref.current) {
      setDimensions({ width: ref.current.offsetWidth, height: ref.current.offsetHeight })
    }
  }, [])

  return (
   <>
      <div ref={ref} className={`floating-image ${isActive ? 'visible' : ''}`} style={{
        transform: `translate(${x - (dimensions.width / 2)}px, ${y - (dimensions.height / 2)}px)`
      }}>
        <Img fluid={image} />
      </div>
      <style jsx>{styles}</style>
    </>
  )
}

MenuImage.propTypes = {
  isActive: false,
  image: {},
  x: 0,
  y: 0
}

MenuImage.defaultProps = {
  isActive: PropTypes.bool.isRequired,
  image: PropTypes.object,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired
}

MenuImage = chainDecorators(decorators, MenuImage)

export default MenuImage
